import React from 'react';

export type EmailSubjectHeaderProps = {
    children?: React.ReactNode | null
    subject: string
};

const EmailSubjectHeader = ({ children = null, subject }: Readonly<EmailSubjectHeaderProps>) => {
    return (
        <div className="card">
            <div className="card-body d-flex align-items-center">
                <div className="flex-fill">
                    <h4 className="m-0 fw-bold">{subject}</h4>
                </div>
                {children}
            </div>
        </div>
    );
};

export default EmailSubjectHeader;